import styled, { css } from 'styled-components'
import { DropdownIconProps } from './types'
import { ReactComponent as Arrow } from '@/assets/images/icons/custom/arrow-solid-up.svg'

export type Variant = 'dark' | undefined

type StylingProps = {
  value: Status
  variant?: Variant
}

type WrapperProps = {
  variant?: Variant
}

type Status = 'approved' | 'waiting' | 'rejected'

export const Button = styled.button<StylingProps>`
  display: flex;
  align-items: center;
  border-radius: 3px;
  border: 0;
  padding: 8px 12px 8px 12px;
  cursor: pointer;

  ${({ theme, value }) => {
    if (value == 'approved') {
      return css`
        svg {
          fill: ${theme.colors.green} !important;
        }
        background-color: ${theme.colors.green}20;
        color: ${theme.colors.green};
      `
    }
    if (value == 'rejected') {
      return css`
        svg {
          fill: ${theme.colors.red} !important;
        }
        background-color: ${theme.colors.red}20;
        color: ${theme.colors.red};
      `
    }
    if (value == 'waiting') {
      return css`
        svg {
          fill: ${theme.colors.yellow} !important;
        }
        background-color: ${theme.colors.yellow}20;
        color: ${theme.colors.yellow};
      `
    }
  }}
`

export const ButtonOption = styled.div<StylingProps>`
  display: flex;
  align-items: center;
  border: 0;
  padding: 8px 12px;
  width: 100%;
  cursor: pointer;
  font-size: 14px;
  :before {
    content: ' ';
    height: 7px;
    width: 7px;
    margin-right: 8px;
    border-radius: 50%;
  }
  :last-child {
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  :first-child {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
  ${({ theme, value, variant }) => {
    if (value == 'approved') {
      return css`
        color: ${variant === 'dark' ? '#fff' : theme.colors.green};
        :before {
          background-color: ${theme.colors.green};
        }
      `
    }
    if (value == 'rejected') {
      return css`
        color: ${variant === 'dark' ? '#fff' : theme.colors.red};
        :before {
          background-color: ${theme.colors.red};
        }
      `
    }
    if (value == 'waiting') {
      return css`
        color: ${variant === 'dark' ? '#fff' : theme.colors.yellow};
        :before {
          background-color: ${theme.colors.yellow};
        }
      `
    }
  }}
  ${({ variant, theme }) => {
    return css`
      :hover {
        background-color: ${variant === 'dark'
          ? theme.colors.abyss
          : theme.colors.lightGrey};
        border-radius: 4px;
      }
    `
  }}
`
export const Wrapper = styled.div<WrapperProps>`
  margin-top: 10px;
  padding: 8px;
  position: absolute;
  min-width: 126px;
  box-shadow: 0px 4px 15px -5px rgba(0, 46, 62, 0.05);
  border-radius: 4px;
  z-index: 1;
  ${({ theme, variant }) => {
    if (variant == 'dark') {
      return css`
        background-color: ${theme.colors.lightAbyss} !important;
        color: ${theme.colors.yellow};
      `
    }

    return css`
      background-color: ${theme.colors.backgroundColor} !important;
      color: ${theme.primaryColor};
    `
  }}
`

export const StatusDropdownContainer = styled.div<{ disabled?: boolean }>`
  z-index: 3;
  max-width: 111px;
  white-space: nowrap;
  ${({ disabled }) => css`
    opacity: ${disabled ? 0.5 : 1};
    pointer-events: ${disabled ? 'none' : 'all'};
  `}
`

export const DropdownIconStyled = styled(Arrow)<DropdownIconProps>`
  width: 10px !important;
  margin-left: 12.3px !important;
  font-size: 10px !important;
  cursor: pointer !important;
  transition: all 0.2s linear;
  ${({ open }) => {
    if (!open) {
      return css`
        transform-origin: center;
        transform: rotate(180deg);
      `
    }
  }}
`
